export const DividerHr = {
  transclude: true,

  template: `
    <div class="divider-hr">
      <span class="d-inline-block bg-white px-3" ng-transclude></span>
      <hr class="divider">
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Dividers/Hr.js